/* import __COLOCATED_TEMPLATE__ from './editable-field.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { dropTask, timeout } from 'ember-concurrency';
import { action } from '@ember/object';
let EditableFieldComponent = (_class = class EditableFieldComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isEditing", _descriptor, this);
    _defineProperty(this, "saveData", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(1);
        const result = yield this.args.save();
        if (result !== false) {
          this.setIsEditing(false);
        }
      }
    }), null, "saveData", "drop"));
    _defineProperty(this, "closeEditor", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(1);
        yield this.args.close();
        this.setIsEditing(false);
      }
    }), null, "closeEditor", "drop"));
  }
  get looksEmpty() {
    const value = this.args.value || '';
    const text = value.toString();
    const noTagsText = text.replace(/(<([^>]+)>)/gi, '');
    const strippedText = noTagsText.replace(/&nbsp;/gi, '').replace(/\s/g, '');
    return strippedText.length === 0;
  }
  focusFirstControl(element) {
    const elements = element.querySelectorAll('input,textarea,select,.fr-element');
    if (elements.length) {
      const visibleControls = Array.from(elements).filter(el => {
        return !el.hidden;
      });
      visibleControls[0].focus();
    }
  }
  keyup(event) {
    const keyCode = event.keyCode;
    const target = event.target;

    // only process key events coming from text input/textarea.
    if (!['text', 'textarea'].includes(target.type)) {
      return;
    }
    if (13 === keyCode && this.args.saveOnEnter) {
      this.saveData.perform();
    } else if (27 === keyCode && this.args.closeOnEscape) {
      this.closeEditor.perform();
    }
  }
  setIsEditing(status) {
    this.isEditing = status;
    if (this.args.onEditingStatusChange) {
      this.args.onEditingStatusChange(status);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "keyup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsEditing"), _class.prototype), _class);
export { EditableFieldComponent as default };